angular.module('zc.projects')
  .component('zcCampaignNote', {
    templateUrl: selectTemplateUrl,
    bindings: {
      campaign: '=',
      colMd: '<',
      note: '@',
      compact: '<',
    },
    controller: ZcCampaignNoteController,
    controllerAs: 'vm',
  })
  .factory('noteOptions', noteConstants);

noteConstants.$inject = ['$filter'];
function noteConstants($filter) {
  return {
    ELEMENT_MAX_WIDTH: 12,
    MAX_CHARACTER_LENGTH: 2000,
    MAX_CHARACTERS_PER_ROW: 80,
    NOTES: {
      base: '',
      template: '',
      incentive: '',
      policy: '',
      timing: '',
      schedule: '',
    },
    NOTES_EXCLUDED_FROM_VALIDATION: [
      'all',
    ],
    NOTE_NAMES_TRANSLATED: {
      base: $filter('translate')('projectsCampaigns.directives.campaignNote.base'),
      template: $filter('translate')('projectsCampaigns.directives.campaignNote.template'),
      botbonnie: 'botbonnie',
      incentive: $filter('translate')('projectsCampaigns.directives.campaignNote.incentive'),
      policy: $filter('translate')('projectsCampaigns.directives.campaignNote.policy'),
      timing: $filter('translate')('projectsCampaigns.directives.campaignNote.timing'),
      schedule: $filter('translate')('projectsCampaigns.directives.campaignNote.schedule'),
    }
  };
}


function selectTemplateUrl($attrs) {
  const MODES = {
    display: '/templates/projects.campaigns/views/directives/campaign_note.html',
    edit: '/templates/projects.campaigns/views/directives/campaign_note_editor.html',
    list: '/templates/projects.campaigns/views/directives/campaign_notes.html',
  };

  const validModes = _.keys(MODES);
  if(!_.includes(validModes, $attrs.mode)) {
    $attrs.mode = MODES.display;
  }

  return MODES[$attrs.mode];
}

ZcCampaignNoteController.$inject = ['noteOptions'];
function ZcCampaignNoteController(noteOptions) {
  const vm = this;
  vm.$onInit = onInit;
  vm.$doCheck = doCheck;

  function onInit() {
    validateNote(vm.note);

    // variables
    vm.maxCharacterLength = noteOptions.MAX_CHARACTER_LENGTH;
    vm.isMultiline = false;

    // make sure campaign has the notes object
    vm.campaign.notes_json = _.defaults(vm.campaign.notes_json, noteOptions.NOTES);

    // functions
    vm.getColMdClass = getColMdClass;
    vm.getTextareaClasses = getTextareaClasses;
    vm.getNotes = getNotes;
    vm.translateNoteName = translateNoteName;
  }


  // used to keep track of note values changes
  let tempNoteValue;
  function doCheck() {
    let noteText = getNote();
    if(tempNoteValue !== noteText) {
      tempNoteValue = noteText;
      vm.isMultiline = isMultiline();
      vm.noteLength = tempNoteValue.length;

      if(!vm.isMultiline && noteOptions.MAX_CHARACTERS_PER_ROW < vm.noteLength) {
        vm.isMultiline = true;
      }
    }
  }


  function validateNote(note) {
    const noteParameters = _.keys(noteOptions.NOTES);
    const noteParametersList = noteParameters.sort().join('\n  ');

    if(!_.includes(noteParameters, note) && !_.includes(noteOptions.NOTES_EXCLUDED_FROM_VALIDATION, note)) {
      throw new Error(`Invalid note parameter "${note}" given.\n Valid notes parameters are:\n↳ ${noteParametersList}`);
    }
  }


  // Returns an object like {'col-md-12': true}
  // which is used for setting elements width
  function getColMdClass(colMd = noteOptions.ELEMENT_MAX_WIDTH) {
    if(colMd > noteOptions.ELEMENT_MAX_WIDTH) {
      colMd = noteOptions.ELEMENT_MAX_WIDTH;
    }

    const colMdObj = {};
    colMdObj['col-md-' + colMd] = true;

    return colMdObj;
  }


  function getTextareaClasses() {
    const textareaClasses = {};
    _.assign(textareaClasses, getColMdClass(vm.colMd));
    return textareaClasses;
  }


  function getNote() {
    return _.get(vm.campaign.notes_json, vm.note, '');
  }


  function getNotes() {
    return _.get(vm.campaign, 'notes_json', {});
  }


  function isMultiline() {
    return getNote().indexOf('\n') > -1;
  }


  function translateNoteName(noteName) {
    return _.get(noteOptions.NOTE_NAMES_TRANSLATED, noteName, noteName);
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.campaigns/directives/campaign_note.js